<!-- 填写并核对订单信息 -->
<template>
    <div id="getOrderInfo" class="business-content-main">
        <div class="order-info-title">填写并核对订单信息</div>
        <div class="order-info-main">
            <div class="step-tit">
                <div class="item-title">
                    收货人信息
                </div>
                <div class="add-address" @click="showAddress">
                    新增收货地址
                </div>
            </div>
            <div class="address-ctn" :class="{'address-open':addressOpen}">
                <div class="address-item"
                     v-for="(item,index) in addressList"
                     :key="item.Id"
                     @click="toggleAddress(item,index)"
                >
                    <div class="add-item" :class="{'target-checked':addressIndex == index}" style="width: 144px">
                        <span>{{item.Tags}}</span>
                        <span class="gou"></span>
                    </div>
                    <div class="add-dir">{{item.Contactor}}</div>
                    <div class="add-dir">{{item.Province}}{{item.City}}{{item.District}}{{item.Addr}}</div>
                    <div class="add-dir">{{item.PhoneNum}}</div>
                    <div class="add-dir default-address" v-if="item.IsDefault">默认地址</div>
                    <div class="ops-ctn">
                        <span @click.stop="setDefault(item)" v-if="!item.IsDefault">设为默认地址</span>
                        <span @click.stop="addressEdit(item)">编辑</span>
                        <span @click.stop="addressDel(item)">删除</span>
                    </div>
                </div>
            </div>
            <div class="open-btn">
                <span @click="openAddress(1)" v-if="addressOpen">展开</span>
                <span @click="openAddress(0)" v-else>收起</span>
            </div>
            <div class="send-goods-list">
                <div class="step-tit">
                    <div class="item-title">
                        送货清单
                    </div>
                    <div class="add-address">
                        <span @click="gotoBuyCar">返回修改</span>
                    </div>
                </div>
                <div class="send-goods-list-main">
                    <div class="goods-list" v-if="dataList">
                        <!-- 优惠活动 -->
                        <div class="div-table-row">
                            <div style="width: 100%">
                                <div class="activity"
                                     v-if="dataList.SinglePromotion || dataList.BuyGivePromotion || dataList.FullDiscountPromotion || dataList.ExchangeBuyPromotion || dataList.isSuit">
                                    <!-- 单品促销 -->
                                    <template v-if="dataList.SinglePromotion">
                                        <template v-if="dataList.SinglePromotion.DiscountType == 0">
                                            <div class="promotion-item">
                                                <div class="promotion-type">折扣</div>
                                                <div class="promotion-dir">{{dataList.SinglePromotion.DiscountValue}}折</div>
                                            </div>
                                        </template>
                                        <template v-else-if="dataList.SinglePromotion.DiscountType == 1">
                                            <div class="promotion-item">
                                                <div class="promotion-type">直降</div>
                                                <div class="promotion-dir">{{dataList.SinglePromotion.DiscountValue}}元</div>
                                            </div>
                                        </template>
                                        <template v-else-if="dataList.SinglePromotion.DiscountType == 2">
                                            <div class="promotion-item">
                                                <div class="promotion-type">折后价</div>
                                                <div class="promotion-dir">{{dataList.SinglePromotion.DiscountValue}}元</div>
                                            </div>
                                        </template>
                                    </template>
                                    <!-- 买送 -->
                                    <template v-if="dataList.BuyGivePromotion">
                                        <div class="promotion-item">
                                            <div class="promotion-type">买送</div>
                                            <div class="promotion-dir">买{{dataList.BuyGivePromotion.BuyCount}}送{{dataList.BuyGivePromotion.SendCount}}</div>
                                        </div>
                                    </template>
                                    <!-- 满减 -->
                                    <template v-if="dataList.FullDiscountPromotion">
                                        <div class="promotion-item">
                                            <div class="promotion-type">满减</div>
                                            <div class="promotion-dir">
                                                满{{dataList.FullDiscountPromotion.LimitMoney1}}减{{dataList.FullDiscountPromotion.CutMoney1}}
                                                <template v-if="dataList.FullDiscountPromotion.LimitMoney2">
                                                    满{{dataList.FullDiscountPromotion.LimitMoney2}}减{{dataList.FullDiscountPromotion.CutMoney2}}
                                                </template>
                                                <template v-if="dataList.FullDiscountPromotion.LimitMoney3">
                                                    满{{dataList.FullDiscountPromotion.LimitMoney3}}减{{dataList.FullDiscountPromotion.CutMoney3}}
                                                </template>
                                            </div>
                                        </div>
                                    </template>
                                    <!-- 换购促销 -->
                                    <template v-if="dataList.ExchangeBuyPromotion">
                                        <div class="promotion-item show-hg-btn" @click="hgShow()">
                                            <div class="promotion-type">换购</div>
                                            <div class="promotion-dir">
                                                满{{dataList.ExchangeBuyPromotion.LimitMoney}}加{{dataList.ExchangeBuyPromotion.AddMoney}}可换购
                                            </div>
                                        </div>
                                    </template>
                                    <!--  套装标识 -->
                                    <template v-if="dataList.isSuit">
                                        <div class="promotion-item">
                                            <div class="promotion-type">套装</div>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                        <!--   主体商品  -->
                        <div class="goods-item" v-if="searchData.GoodsType == 5">
                            <div class="image-ctn goods-cover">
                                <img :src="downloadUrl+ dataList.Goods.ShowImg" :onerror="defaultImg">
                            </div>
                            <div class="goods-dir">
                                <div class="goods-name" :title="dataList.Goods.Name">
                                    {{dataList.Goods.Name}}
                                </div>
                            </div>
                            <div class="goods-price">
                                <p>￥{{zhMoney}}</p>
                            </div>
                            <div class="goods-num">
                                <inputNumber
                                        :index="-1"
                                        :data="{BuyCount:BuyCount}"
                                        @change="handleNumChange"
                                ></inputNumber>
                            </div>
                        </div>
                        <!--  主体套装 -->
                        <div v-else>
                            <div class="div-table-row">
                                <div class="div-table-cell">
                                    <div>
                                        <div :key="index" v-for="(suit,index) in dataList.PackageGoods.PackageGoodsList">
                                            <div class="suit-item">
                                                <div style="width:400px">
                                                    <div class="order-msg">
                                                        <img :src="down_url+suit.ShowImg" alt="" class="shop-cover" :onerror="defaultImg">
                                                        <div class="goods-name" :title="suit.Name">
                                                            {{suit.Name}}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div style="width:80px">
                                                    <span class="suit-price">￥{{suit.zhMoney}} </span>
                                                    <span>x{{suit.Number}}</span>
                                                </div>
                                                <div style="width:100px">

                                                </div>
                                            </div>
                                            <!-- 赠品 -->
                                            <div class="suit-item" v-if="suit.GiftPromotion">
                                                <template v-for="(gift,index) in suit.GiftPromotion.GiftGoodsList" >
                                                    <div :key="index" style="width:400px">
                                                        <div class="order-msg">
                                                            <img :src="down_url + gift.ShowImg" class="gift-cover">
                                                            <div class="goods-name">
                                                                <span class="goods-type-icon">赠品</span>{{gift.Name}}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div :key="index" style="width:80px">
                                                        <span class="suit-price">￥0</span>
                                                        <span> x{{gift.Number * item.BuyCount}}</span>
                                                    </div>
                                                    <div :key="index" style="width:100px">

                                                    </div>
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="div-table-cell" style="width:140px">
                                    <inputNumber
                                            :max="999"
                                            :index="index"
                                            :data="item"
                                            @change="handleNumChange"
                                    >
                                    </inputNumber>
                                </div>
                                <div style="width:80px" class="div-table-cell color-red">
                                    ￥{{item.zhMoneyCount}}
                                </div>
                                <div class="border-right div-table-cell" style="width:207px">
                                    <el-button @click="delGoods(index)" type="text" size="small">删除</el-button>
                                </div>
                            </div>
                        </div>
                        <!-- 买送商品 -->
                        <div style="display:flex;align-items:center" v-if="canMs">
                            <div style="width:400px;">
                                <div class="order-msg">
                                    <div class="image-ctn gift-cover">
                                        <img :src="downloadUrl + dataList.Goods.ShowImg">
                                    </div>
                                    <div class="goods-name" style="width: 250px">
                                        <span class="goods-type-icon">买送</span>{{dataList.Goods.Name}}
                                    </div>
                                </div>
                            </div>
                            <div style="width:80px">
                                ￥0&nbsp;&nbsp;&nbsp;&nbsp;x{{msNum}}
                            </div>
                        </div>
                        <!-- 赠品 -->
                        <div style="display:flex;align-items:center" v-if="dataList.GiftPromotion">
                            <template v-for="(gift,index) in dataList.GiftPromotion.GiftGoodsList" >
                                <div :key="index" style="width:400px">
                                    <div class="order-msg">
                                        <img :src="downloadUrl + gift.ShowImg" class="gift-cover">
                                        <div class="goods-name">
                                            <span class="goods-type-icon">赠品</span>{{gift.Name}}
                                        </div>
                                    </div>
                                </div>
                                <div :key="index" style="width:80px">
                                    ￥0&nbsp;&nbsp;&nbsp;&nbsp;x{{gift.Number * dataList.Goods.BuyQuantity}}
                                </div>
                            </template>
                        </div>
                        <!-- 换购商品 -->
                        <div  style="display:flex;align-items:center" v-if="hgGoods.Name">
                            <div style="width:400px">
                                <div class="order-msg">
                                    <img :src="downloadUrl + hgGoods.ShowImg" class="gift-cover">
                                    <div class="goods-name">
                                        <span class="goods-type-icon">加价购</span>{{hgGoods.Name}}
                                    </div>
                                </div>
                            </div>
                            <div style="width:80px">
                                ￥{{hgGoods.ShopPrice}}&nbsp;&nbsp;&nbsp;&nbsp;x1
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 优惠 -->
            <div class="coupon" :class="{'coupon-open':couponOpen}">
                <div class="item-title">使用优惠券</div>
                <el-table
                        :header-cell-style="{background:'#F2F6FC'}"
                        :show-header="showHeader"
                        :data="couponList"
                        style="width: 100%">
                    <el-table-column
                            show-overflow-tooltip
                            prop="Name">
                    </el-table-column>
                    <el-table-column show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{scope.row|couponHandle}}
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip>
                        <template slot-scope="scope">
                            <div class="ops-ctn">
                                有效期{{scope.row.UseDate}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip>
                        <template slot-scope="scope">
                            <div class="ops-ctn">
                                <el-checkbox v-model="scope.row.checked" @change="handleCouponChange(scope.$index)"></el-checkbox>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="open-btn">
                <span @click="openCoupon(1)" v-if="couponOpen">收起</span>
                <span @click="openCoupon(0)" v-else>展开</span>
            </div>
            <div class="money-count">
                <div>
                    <p v-if="dataList">
                        <span class="key">{{dataList.Goods.BuyQuantity}} 件商品，总商品金额:</span>
                        <span class="value">￥{{countMoney}}</span>
                    </p>
                    <p>
                        <span class="key">
                             <el-tooltip class="item" effect="light">
                                 <div slot="content">订单可能会产生运费<br>如果产生运费会有客服与您沟通具体细节</div>
                                <i class="el-icon-question" style="color: orange"></i>
                             </el-tooltip>
                            运费:
                        </span>
                        <span class="value">￥0.00</span>
                    </p>
                    <p>
                        <span class="key">商品优惠:</span>
                        <span class="value">￥{{favorable}}</span>
                    </p>
                </div>
            </div>
            <div class="trade-foot-detail-com">
                <div>应付总额：<span class="price-num">￥{{finalMoney}}</span> </div>
                <div>
                  <span>寄送至： {{chooseAddress.Province}}{{chooseAddress.City}}{{chooseAddress.District}}{{chooseAddress.Addr}} </span>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <span>收货人：{{chooseAddress.Contactor}} {{chooseAddress.PhoneNum}}</span>
                </div>
            </div>
            <div class="sub-btn-ctn">
                <div class="sub-btn" @click="submitData">提交订单</div>
            </div>
        </div>
        <!--   换购弹窗   -->
        <el-dialog
                :close-on-click-modal="false"
                width="800px"
                title="选择换购商品"
                :visible.sync="showHg">
            <div class="goods-main hg-goods" v-for="(item,index) in hgList" :key="index">
                <div style="width:50px">
                    <el-checkbox v-model="item.checked"></el-checkbox>
                </div>
                <div style="width:400px">
                    <div class="order-msg">
                        <img :src="downloadUrl + item.ShowImg" class="gift-cover">
                        <div :title="item.Name">
                            {{item.Name}}
                        </div>
                    </div>
                </div>
                <div style="width:80px">
                    ￥{{item.ShopPrice}}&nbsp;&nbsp;&nbsp;&nbsp; x1
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="showHg = false">取 消</el-button>
                <el-button class="btn-primary" @click="addHg">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog
                :close-on-click-modal="false"
                title="地址"
                :before-close="handleClose"
                :visible.sync="dialogVisible"
                custom-class="base-dialog"
                width="800px"
        >
            <addAddress
                    ref="addAddress"
                    :submitType="addressType"
                    :addrData="this.addressData"
                    :areaSelect="this.areaSelect"
                    @resetData="clearDialog"
                    @loadData="changeAddress">
            </addAddress>
        </el-dialog>
    </div>
</template>
<script>
    import inputNumber from '@/components/common/inputNumber'
    import addAddress from '@/components/common/addAddress'
    import mixin from  '@/mixins/mixin'
    export default {
        mixins: [mixin],
        name: '',
        components: {
            inputNumber,
            addAddress
        },
        data(){
            let userMsg = this.$util.getLocalStorage("userMsg");
            return {
                userMsg:userMsg,
                canRequest:true,
                BuyCount:1,
                noAddress:false,
                showPromotion:false, // 促销
                GoodsTypeId:'',
                zhMoney:0, // 折后单价
                chosenCoupon:[], // 选中的优惠券，目前是单选，但还是写成数组吧
                canMs:false, // 是否可以买送
                msNum:1,     // 满送数量
                hgGoods:{},  // 换购商品信息
                canHg:false, // 是否可以换购
                finalMoney:0,// 最终实付价格
                countNum:0,
                favorable:0,    // 优惠
                countMoney:0,   // 原价
                couponList:[],  // 可选优惠券列表
                receiveAddress:{}, // 地址
                hgList:[],      // 换购
                showHg:false,
                showCoupon:false,
                showLayer:false,
                downloadUrl:this.$util.QN_URL_BASE,
                defaultImg:'this.src="' + this.$util.DEFAULT_IMAGE_square + '"',
                searchData:{
                    UserId:userMsg.EmployeeId,
                    GoodsId:'',
                    GoodsType:'',
                },
                dataList:null,
                couponOpen:false,
                showHeader:false,
                invoiceVisible:false,
                addressType:1, //
                dialogVisible:false,
                addressList:[],
                addressIndex:0,
                addressOpen:true,
                addressData:{},
                areaSelect:[],  // 地址三级联动
                chooseAddress:{}, // 选中的地址
            }
        },
        mounted(){
            this.initPage()
        },
        filters:{
            couponHandle(item){
                if(item.Type == 0){
                    return `付款时代现金${item.CValue}元`
                }
                else if (item.Type == 1){
                    return `付款时订单打${item.CValue}折`
                }
                else if(item.Type == 3){
                    return `满${item.OrderAmountLower}减${item.CValue}元`
                }
            },
        },
        methods:{
            handleClose(){
                this.$refs.addAddress.resetForm()
                this.dialogVisible = false
            },
            clearDialog(){
                this.$refs.addAddress.resetForm()
                this.dialogVisible = false
            },
            // 提交
            submitData(){
                if(!this.chooseAddress.Id){
                    this.$util.warningMsg('请选择地址')
                    return
                }
                if (!this.canRequest){
                    return;
                }
                this.canRequest = false
                this.$util.axiosPost({
                    url:'/api/MallSaleOrder/SubmitSaleOrder',
                    data:{
                        "UserId": this.userMsg.EmployeeId,
                        "addressId": this.chooseAddress.Id,
                        "goodsId": this.GoodsTypeId,
                        "goodsType": this.searchData.GoodsType,
                        "exchangeBuyPromotionId": this.hgGoods.GoodsId?this.dataList.ExchangeBuyPromotion.ExchangeBuyPromotionId:'',
                        "exchangeBuyGoodsId": this.hgGoods.GoodsId,
                        "couponIds": this.chosenCoupon[0]?this.chosenCoupon[0].CouponId:'',
                        "buyQuantity": this.countNum
                    }
                }).then((res)=>{
                    this.canRequest = true
                    this.$router.push(`./pay?osn=${res.data}`)
                }).catch(()=>{
                    this.canRequest = true
                })
            },
            // 绑定换购商品
            addHg(){
                let  flag = false
                let _hgList = this.hgList
                for (let i = 0;i< _hgList.length;i++){
                    if(_hgList[i].checked){
                        this.hgGoods = _hgList[i]
                        flag =true
                    }
                }
                if (!flag){
                    this.hgGoods = {}
                }
                this.showHg = false
                this.countData()
            },
            // 显示换购弹窗
            hgShow (){
                if (this.canHg){
                    this.hgList = this.dataList.ExchangeBuyPromotion.ExchangeBuyGoodsList
                    this.showHg = true
                }
                else {
                    this.$util.warningMsg('未达到换购要求')
                }
            },
            openCoupon(flag){
                if (flag){
                    this.couponOpen = false
                }
                else {
                    this.couponOpen = true
                }
            },
            initPage(){
                this.searchData.GoodsId = this.$route.query.GoodsId
                this.searchData.GoodsType = this.$route.query.GoodsType
                this.GoodsTypeId = this.$route.query.GoodsTypeId
                this.BuyCount = this.$route.query.number?this.$route.query.number:1
                this.getAddressList()
                this.getData()
            },
            // 改变商品数量
            handleNumChange(data,value){
                this.dataList.Goods.BuyQuantity = value
                this.countData()
            },
            // 获取数据
            getData(){
                this.$util.axiosGet({
                    url:'/api/MallGoods/GetConfirmationGoods',
                    data:this.searchData
                }).then((res)=>{
                    let _data = res.data
                    // 单个商品
                    if (this.searchData.GoodsType == 5){
                        _data.Goods.BuyQuantity = 1
                        // 如果有换购活动
                        if (_data.ExchangeBuyPromotion){
                            this.hgList = _data.ExchangeBuyPromotion.ExchangeBuyGoodsList
                        }
                    }
                    // 套装
                    else {
                        _data.Goods = {}
                        _data.Goods.BuyQuantity = 1
                        let _list = _data.PackageGoods.PackageGoodsList
                        // 计算套装内商品的实际价格
                        for(let i=0;i<_list.length;i++){
                            _list[i].ShopPrice = _list[i].ShopPrice - _list[i].Discount
                        }
                    }
                    this.dataList = _data
                    this.couponList = _data.CouponList
                    this.dataList.Goods.BuyQuantity = this.BuyCount
                    this.countData()
                }).catch(()=>{})
            },
            // 商品价格和优惠统计
            countData(){
                let _hgList = this.hgList
                let _dataList = this.dataList
                let _data = null
                let _countNum = 0
                let _countMoney = 0
                let _finalMoney = 0
                // 商品
                if(this.searchData.GoodsType == 5){
                    _countNum = _dataList.Goods.BuyQuantity
                    _countMoney = _dataList.Goods.ShopPrice * _countNum
                    _finalMoney = _countMoney + _dataList.Freight
                }
                // 套装
                else if(this.searchData.GoodsType == 10){
                    _data = _dataList.PackageGoods.PackageGoodsList
                    _countNum = _dataList.Goods.BuyQuantity
                    for (let i=0;i<_data.length;i++){
                        _countMoney += (_data[i].ShopPrice + _data[i].Discount) * _data[i].Number*_dataList.Goods.BuyQuantity
                        _finalMoney += _data[i].ShopPrice * _data[i].Number*_dataList.Goods.BuyQuantity
                    }
                }
                this.finalMoney = this.$util.num2Float(_finalMoney)
                this.countNum = _countNum
                this.countMoney = this.$util.num2Float(_countMoney + _dataList.Freight)
                this.zhMoney = _dataList.Goods.ShopPrice
                // 判断是否达到换购条件
                if(_dataList.ExchangeBuyPromotion){
                    if(this.finalMoney > _dataList.ExchangeBuyPromotion.LimitMoney){
                        this.canHg = true
                    }
                    else {
                        this.canHg = false
                        this.hgGoods = {}
                        // for (let i = 0;i< _hgList.length;i++){
                        //     _hgList[i].checked = false
                        // }
                    }
                }
                // 判断是否达到满送条件
                if(_dataList.BuyGivePromotion){
                    if (this.countNum >= _dataList.BuyGivePromotion.BuyCount){
                        this.canMs = true
                        this.msNum = parseInt(this.countNum / _dataList.BuyGivePromotion.BuyCount) * _dataList.BuyGivePromotion.SendCount
                    }
                    else {
                        this.canMs = false
                    }
                }
                /**
                 * 综合各种优惠算总价
                 * */
                // 单品促销 lv1
                if (this.dataList.SinglePromotion){
                    this.finalMoney = this.SinglePromotionHandle(_dataList.SinglePromotion,_dataList.Goods.ShopPrice) * _dataList.Goods.BuyQuantity + _dataList.Freight
                    this.zhMoney = this.SinglePromotionHandle(_dataList.SinglePromotion,_dataList.Goods.ShopPrice)
                }
                // 换购 lv2
                if (this.hgGoods.ShopPrice){
                    this.finalMoney = this.finalMoney + _dataList.ExchangeBuyPromotion.AddMoney
                    this.countMoney = this.countMoney + _dataList.ExchangeBuyPromotion.AddMoney
                }
                // 满减优惠 lv3
                if (_dataList.FullDiscountPromotion) {
                    if(this.finalMoney >= _dataList.FullDiscountPromotion.LimitMoney3){
                        this.finalMoney =  this.finalMoney - _dataList.FullDiscountPromotion.CutMoney3
                    }
                    else if(this.finalMoney >= _dataList.FullDiscountPromotion.LimitMoney2){
                        this.finalMoney =  this.finalMoney - _dataList.FullDiscountPromotion.CutMoney2
                    }
                    else if(this.finalMoney >= _dataList.FullDiscountPromotion.LimitMoney1){
                        this.finalMoney =  this.finalMoney - _dataList.FullDiscountPromotion.CutMoney1
                    }
                }
                // 优惠券 lv4
                if(this.chosenCoupon[0]){
                    if(this.chosenCoupon[0].Type == 3){
                        if(this.finalMoney < this.chosenCoupon[0].OrderAmountLower){
                            let _data = this.couponList
                            for (let i = 0;i<_data.length;i++){
                                _data[i].checked = false
                            }
                            this.chosenCoupon = [{Type:-1}]
                        }
                    }
                    //优惠券类型（0 代金券；1 折扣券；2 积分兑换券（暂不考虑）；3满减券）
                    if (this.chosenCoupon[0].Type == 0){
                        this.finalMoney = this.finalMoney -  this.chosenCoupon[0].CValue
                    }
                    else if(this.chosenCoupon[0].Type == 1){
                        this.finalMoney = this.finalMoney *  this.chosenCoupon[0].CValue * 0.1
                    }
                    // else if(this.chosenCoupon[0].Type == 2){

                    // }
                    else if(this.chosenCoupon[0].Type == 3){
                        this.finalMoney = this.finalMoney -  this.chosenCoupon[0].CValue
                    }
                    else if(this.chosenCoupon[0].Type == -1){
                        this.finalMoney = this.finalMoney
                    }
                }
                this.favorable = this.$util.num2Float(this.countMoney - this.finalMoney)    // 优惠
                this.finalMoney = this.$util.num2Float(this.finalMoney)
            },
            // 单品促销处理
            SinglePromotionHandle(Promotion,price){
                if(Promotion.DiscountType == 0){
                    return price * Promotion.DiscountValue * 0.1
                }
                else if(Promotion.DiscountType == 1){
                    return price - Promotion.DiscountValue
                }
                else if(Promotion.DiscountType == 2) {
                    return Promotion.DiscountValue
                }
            },
            // 选择优惠券
            handleCouponChange(index){
                this.chosenCoupon = []
                let _data = this.couponList
                if (!_data[index].checked){
                    this.chosenCoupon = []
                    for (let i = 0;i<_data.length;i++){
                        this.$set(this.couponList[i],'checked',false)
                    }
                }
                else {
                    for (let i = 0;i<_data.length;i++){
                        this.$set(this.couponList[i],'checked',false)
                    }
                    // 判断这张券能不能用
                    let _chosen = this.couponList[index]
                    if(_chosen.Type == 3){
                        if(this.countMoney < _chosen.OrderAmountLower){
                            this.$util.warningMsg('不满足使用条件')
                            return
                        }
                    }
                    this.$set(this.couponList[index],'checked',true)
                    this.chosenCoupon[0] = this.couponList[index]
                }
                this.countData()
            },

            // 地址添加成功后要进行的操作
            changeAddress(type,data){
                this.getAddressList();
                this.clearDialog()
            },
            // 关闭发票
            closeInvoice(){
                this.invoiceVisible = false
            },
            // 显示发票
            editInvoice(){
                this.invoiceVisible = true
            },
            // 设为默认地址
            setDefault(data){
                this.$util.axiosPost({
                    url:'/api/PurchaseManager/SetASDefaultAddress',
                    data:{
                        "addrId": data.Id,
                        "entpId": this.userMsg.EntpId,
                        "operator": this.userMsg.EmployeeId,
                    },
                }).then(()=>{
                    this.getAddressList()
                }).catch(()=>{})
            },
            // 编辑
            addressEdit(data){
                this.addressType = 2
                this.addressData = data
                this.areaSelect = [data.Province,data.City,data.District]
                this.dialogVisible = true
            },
            // 删除
            addressDel(data){
                let that = this
                this.$util.elConfirm({
                    content:'确定要删除该地址吗？',
                    confirm(){
                        that.$util.axiosGet({
                            url:'/api/EntpInfoManagement/DeleteAddress',
                            data:{
                                AddrId:data.Id,
                                Uid:that.userMsg.EmployeeId,
                            },
                        }).then(()=>{
                            that.getAddressList()
                        }).catch(()=>{})
                    },
                })
            },

            // 展开收起地址
            openAddress(flag){
                if (flag){
                    this.addressOpen = false
                }
                else {
                    this.addressOpen = true
                }
            },
            // 切换地址
            toggleAddress(item,index){
                this.addressList.splice(index,1)
                this.addressList.unshift(item)
                this.addressOpen = true
                this.chooseAddress = item
            },
            // 获取地址列表
            getAddressList(){
                this.$util.axiosGet({
                    url:'/api/EntpInfoManagement/GetAddressList',
                    data:{
                        EntpId:this.userMsg.EntpId
                    },
                }).then((res)=>{
                    let data = res.data
                    this.addressList = data
                    this.chooseAddress = data[0]
                }).catch(()=>{})
            },
            // 跳转购物车
            gotoBuyCar (){
                window.history.back(-1);
            },
            // 显示新增地址弹窗
            showAddress(){
                this.dialogVisible = true
            },
        }
    }
</script>
<style lang="less" scoped>
    .hg-goods {
        display: flex;
        align-items: center;
    }
    .show-hg-btn {
        cursor: pointer;
    }
    .order-msg {
        display: flex;
        padding: 20px;
        justify-content: space-between;
        align-items: center;
    }
    .gift-type {
        padding-left: 70px;
    }
    .goods-type-icon {
        border: 1px solid red;
        background:#ffdedf;
        color: red;
        padding: 0 5px;
        border-radius: 5px;
        margin-right: 5px;
    }
    .gift-cover {
        width: 70px;
        height: 70px;
        margin-right: 20px;
        margin-left: 10px;
        img {
            max-width: 70px;
            max-height: 70px;
        }
    }
    .activity {
        display: flex;
        padding: 5px 0;
    }
    .promotion-item {
        display: flex;
        margin-right: 20px;
    }
    .promotion-dir {
        height: 20px;
        line-height: 20px;
        margin-right: 5px;
    }
    .promotion-type {
        background: red;
        color: white;
        width: 50px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        margin-right: 5px;
    }
    .coupon-open {
        height: auto !important;
    }
    .goods-cover {
        width: 100px;
        height: 100px;
        img {
            max-width: 100px;
            max-height: 100px;
        }
    }
    .toggle-item {
        display: none;
    }
    .business-content-main {
        margin: 0 auto;
        max-width: 1200px;
    }
    .pay-way-item {
        min-width: 140px;
        width: auto !important;
        margin-bottom: 10px;
    }
    .address-item {
        position: relative;
        &:hover {
            background: @border3Color;
            .ops-ctn {
                display: block;
            }
        }
        .ops-ctn {
            display: none;
            position: absolute;
            line-height: 26px;
            top: 0;
            right: 0;
            span {
                cursor:pointer;
                color: #005ea7;
                margin-left: 10px;
            }
        }
    }
    .address-open {
        height: 46px;
    }
    .address-ctn {
        overflow: hidden;
    }
    .sub-btn-ctn {
        text-align: right;
        padding-bottom: 30px;
    }
    .sub-btn {
        text-align: center;
        position: relative;
        width: 135px;
        height: 36px;
        line-height: 36px;
        margin: 8px 0 0;
        background-color: @theme;
        color: #fff;
        font-weight: 700;
        font-size: 16px;
        font-family: arial,"Microsoft YaHei";
        display: inline-block;
        border-radius: 3px;
        cursor: pointer;
    }
    .price-num {
        color: #e4393c;
        font-family: Verdana;
        font-weight: 700;
        font-size: 18px;
        min-width: 122px;
        width: 122px;
    }
    .trade-foot-detail-com {
        background: @border3Color;
        padding: 10px;
        text-align: right;
        >div {
            margin-bottom: 20px;
        }
    }
    .money-count {
        display: flex;
        justify-content: flex-end;
        padding-top: 10px;
        padding-right: 10px;
        span {
            display: inline-block;
        }
        p {
            padding-bottom: 20px;
        }
        .key {
            width: 200px;
            text-align: right;
        }
        .value {
            width: 100px;
            text-align: right;
        }
    }
    .coupon-money {
        width: 100%;
        background-color:@border3Color;
        display: block;
        clear: both;
        height: 38px;
        margin-top: 15px;
        padding: 10px 20px;
        font-size: 12px;
    }
    .couponLv2Tab {
        padding: 20px 0;
        display: flex;
        >div {
            cursor: pointer;
            margin-right:50px;
        }
    }
    .tabLv2-active {
        border-bottom: 2px solid @theme;
        color: @theme;
    }
    .coupon-type {
        margin-top: 20px;
        border: 1px solid @border3Color;
    }
    .coupon-tab {
        display: flex;
        background: @border3Color;
        >div {
            cursor: pointer;
            width: 100px;
            height: 38px;
            line-height: 38px;
            text-align: center;
        }
    }
    .item-title {
        font-weight: bold;
        padding-bottom: 20px;
    }
    .coupon {
        padding-top: 20px;
        height: 100px;
        overflow: hidden;
    }
    .edit-invoice {
        cursor: pointer;
        color: #005ea7;
    }
    .invoice-type {
        padding-top: 20px;
        padding-left: 20px;
        padding-bottom: 20px;
        border-bottom: 1px solid @border3Color;
        >span {
            display: inline-block;
            margin-right: 30px;
        }
    }
    .triangle{
        width: 0;
        height: 0;
        border-top: 8px solid transparent;
        border-right: 10px solid @border3Color;
        border-bottom: 8px solid transparent;
    }
    .invoice-title {
        font-weight: bold;
        margin-right: 10px;
    }
    .invoice-msg {
        margin-top: 20px;
        padding-top: 20px;
        border-top: 1px solid @border3Color;
        display: flex;
        align-items: center;
        .tooltip {
            border-radius: 5px;
            padding: 0 10px;
            height: 30px;
            line-height: 30px;
            background: @border3Color;
            font-size: 12px;
        }
    }
    .add-dir {
        padding-right: 30px;
    }
    .goods-inventory {
        width: 80px;
        text-align: right;
    }
    .goods-num {
        padding-left: 20px;
        width: 170px;
        text-align: right;
    }
    .goods-price {
        width: 100px;
        text-align: right;
        >p:nth-child(1){
            color: red;
            font-size: 16px;
            font-weight: bold;
        }
        >p:nth-child(2){
            font-size: 12px;
        }
    }
    .goods-item {
        display: flex;
        align-items: center;
        padding-right: 20px;
        margin:10px 0;
        padding-bottom:10px ;
    }
    .goods-dir {
        width: 300px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 10px 0 10px 20px;
    }
    .goods-weight {
        position: absolute;
        left: 20px;
        bottom: 10px;
        font-weight: bold;
    }
    .business-content-main {
        min-width: 1000px;
    }
    .mode-tab-nav {
        display: flex;
        margin: 10px 0 20px;
    }
    .order-info-title {
        height: 42px;
        line-height: 42px;
        font-size: 16px;
        font-family: "Microsoft YaHei";
        overflow: hidden;
    }
    .order-info-main {
        border:1px solid @border3Color;
        padding: 0 20px;
    }
    .step-tit {
        line-height: 40px;
        height: 40px;
        color: #333;
        display: flex;
        justify-content: space-between;
    }
    .add-address {
        color: #005ea7;
        cursor: pointer;
    }
    .default-address {
        color: white;
        background: @font3Color;
        padding: 5px;
    }
    .pay-way-ctn {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        padding-bottom: 10px;
    }
    .send-goods-list-main {
        display: flex;
        position: relative;
    }
    .send-way {
        width: 300px;
        background: @border3Color;
        padding: 10px 10px 30px 20px;
    }
    .goods-list {
        flex-grow:1;
        background: @border4Color;
        padding: 20px;
    }
    .open-btn {
        cursor: pointer;
        color: @theme;
    }
    .coupon-title {
        color: @theme;
        padding: 20px 0 10px 0;
        font-size: @font-sm;
    }
</style>
